import { render } from "./FaqBlock.vue?vue&type=template&id=b4182f44"
import script from "./FaqBlock.vue?vue&type=script&lang=js"
export * from "./FaqBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__